const ALL_ELIGIBLE_USERS_OPTION = { id: 'all', name: 'All Eligible Users' }

export function buildApprovalUserOptions(options, selectedUserId) {
  const normalizedOptions = Array.isArray(options) ? options : []
  const selectedValue = String(selectedUserId || 'all')
  const hasSelectedOption = selectedValue === 'all'
    || normalizedOptions.some((option) => String(option.id) === selectedValue)

  const stableOptions = hasSelectedOption
    ? normalizedOptions
    : [{ id: selectedValue, name: `User #${selectedValue}` }, ...normalizedOptions]

  return [ALL_ELIGIBLE_USERS_OPTION, ...stableOptions]
}
